/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Pdfonly2Inputs */

const en_coinvestments_pdfonly2 = /** @type {(inputs: Coinvestments_Pdfonly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF only`)
};

/**
* | output |
* | --- |
* | "PDF only" |
*
* @param {Coinvestments_Pdfonly2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_pdfonly2 = /** @type {((inputs?: Coinvestments_Pdfonly2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Pdfonly2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_pdfonly2(inputs)
});
export { coinvestments_pdfonly2 as "coInvestments_pdfOnly" }